var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{staticClass:"fz14 fw500 text-dark1",attrs:{"id":"checkbox-1","name":"checkbox-1"},on:{"change":_vm.changeStatusCheckbox},model:{value:(_vm.statusLocal),callback:function ($$v) {_vm.statusLocal=$$v},expression:"statusLocal"}},[_vm._v(" Income ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }